import { generateShortUuid } from 'ag-common-svc/shared/utils/generate-item-uuid';

export enum FormWidgetDataKeys {
  id = 'id',
  formDbId = 'formDbId',
  formName = 'formName',
  sendEmailTo = 'sendEmailTo',
  subject = 'subject',
  thanksMessage = 'thanksMessage',
}
export class FormWidgetData {
  [FormWidgetDataKeys.id]: string;
  [FormWidgetDataKeys.formDbId]: string;
  [FormWidgetDataKeys.formName]: string;
  [FormWidgetDataKeys.subject]?: string = '';
  [FormWidgetDataKeys.thanksMessage]?: string =
    '<h2 style="text-align: center;">Thank You!</h2><p style="margin: 0px; padding: 0px; text-align: center;">Your submission has been received.</p>';
  [FormWidgetDataKeys.sendEmailTo]: string[] = [];

  constructor() {
    this.id = generateShortUuid();
  }
}
